"use client";

import { useEffect } from "react";

interface ConfettiAnimationProps {
  isVisible: boolean;
  animationData?: any;
}

export const ConfettiAnimation = ({ isVisible }: ConfettiAnimationProps) => {
  useEffect(() => {
    if (isVisible) {
      // @ts-expect-error - canvas-confetti does not have type definitions
      import("canvas-confetti").then((confetti: any) => {
        confetti.default({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.3 },
          zIndex: 9999,
        });

        setTimeout(() => {
          confetti.default({
            particleCount: 50,
            spread: 100,
            origin: { y: 0.4 },
            zIndex: 9999,
          });
        }, 100);
      });
    }
  }, [isVisible]);

  return null;
};
